import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-product-links-change',
  templateUrl: './product-links-change.component.html',
  styleUrls: ['./product-links-change.component.css']
})
export class ProductLinksChangeComponent implements OnInit {
    argType;

    argValue;

    productLinkTypeKeyno;

    public setting?: Setting;

    public itemsListChanges: Item[] = [];

    public saving = false;

    public searchTextButtons: FormButton[] = [
        { id: 'erase', type: 'danger', icon: 'fa fa-eraser', onClick: () => this.clear('searchtext') },
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.searchItems() }
    ];

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
        this.productLinkTypeKeyno = this.stateService.getStateParams()['productlinktype_keyno'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue && !!this.productLinkTypeKeyno) {
            this.setting = (await this.datatask.Post(1828, {
                argtype: this.argType,
                argvalue: this.argValue,
                productlinktype_keyno: this.productLinkTypeKeyno
            }))[0];
        }
    }

    private async loadProductLinksChanges() {
        if (!this.setting) return;

        this.itemsListChanges = await this.datatask.Post(1829, this.setting);
    }

    public async saveChanges() {
        if (!!this.setting) {
            try {
                this.saving = true;

                const selectedItems = this.itemsListChanges.filter((item) => item.item_is_selected === '1').map((item) => ({
                    item_id: item.item_id,
                    item_is_selected: item.item_is_selected
                }));

                const response = (await this.datatask.Post(1830, {
                    argtype: this.setting.argtype,
                    argvalue: this.setting.argvalue,
                    productlinktype_keyno: this.setting.productlinktype_keyno,
                    bg_productlinkschange_function: this.setting.bg_productlinkschange_function,
                    records: selectedItems
                }))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public onTabChange() {
        this.loadProductLinksChanges();
    }

    private clear(id: string) {
        switch (id) {
            case 'searchtext':
                if (!!this.setting) {
                    this.setting.searchtext = '';

                    if (this.setting?.searchtext === '') this.loadProductLinksChanges();
                }
                break;
            default:
                break;
        }
    }

    public searchItems() {
        this.loadProductLinksChanges();
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'searchtext':
                if (this.setting?.searchtext === '') this.loadProductLinksChanges();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadProductLinksChanges();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    argtype: string;
    argvalue: string;
    productlinktype_keyno: string;
    page_heading: string;
    prod_id: string;
    prod_keyno: string;
    searchtext: string;
    bg_productlinkschange_function: string;
}
